import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/layout/App';
// import registerServiceWorker from './registerServiceWorker';
import { CookiesProvider } from 'react-cookie';

import './index.css';
import 'typeface-roboto'

ReactDOM.render(<CookiesProvider><App /></CookiesProvider>, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js